import { useCallback, useEffect, useState } from 'react';
import { useAufgabenExercise } from './useAufgabenExercise';
import { StoreModel } from '@/stores/store';

export function useAufgabenExerciseText(
  setId: string,
  localWordsetProp: any,
  patientId: string,
  goHome: any,
  isSelf: boolean,
  activatedExerciseModalities: keyof StoreModel['selfTrainingSelection'],
) {
  const [scope, setScope] = useState({
    audioUrl: '',
    exerciseState: 'text',
    exercise: null,
  });

  const {
    state,
    activeExercise,
    skip,
    PAGER_OPTIONS,
    isSolved,
    notSolved,
    maxNumOfExercises,
    touched, //?  useTimeService return value
    goSelect,
    checkProgress,
  } = useAufgabenExercise(
    setId,
    true,
    patientId,
    localWordsetProp,
    goHome,
    isSelf,
    activatedExerciseModalities,
  );

  const showQuestions = useCallback(() => {
    setScope((prevState) => ({ ...prevState, exerciseState: 'questions' }));
  }, []);

  const back = useCallback(() => {
    setScope((prevState) => ({ ...prevState, exerciseState: 'text' }));
  }, []);

  useEffect(() => {
    if (!activeExercise) return;
    // audioSpeedSetting is only relevant in Aufgaben
    if (state?.settings?.audioSpeedSetting === 'slow' && !isSelf) {
      const audioUrl = activeExercise.textSlowAudioURL;
      setScope({
        exerciseState: 'text',
        audioUrl,
        exercise: { ...activeExercise, name: activeExercise.type },
      });
    } else {
      const audioUrl = activeExercise.textNormalAudioURL;
      setScope({
        exerciseState: 'text',
        audioUrl,
        exercise: { ...activeExercise, name: activeExercise.type },
      });
    }
  }, [JSON.stringify(state.settings), JSON.stringify(activeExercise)]);

  return {
    showQuestions,
    back,
    state,
    activeExercise,
    skip,
    PAGER_OPTIONS,
    isSolved,
    notSolved,
    scope,
    maxNumOfExercises,
    touched, //?  useTimeService return value
    goSelect,
    checkProgress,
  };
}
